import { NgModule, Optional, SkipSelf } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './interceptors/auth.interceptor';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCoffee, faDumbbell, faGlobe, faKey, faLock, faLockOpen, faNewspaper, faUser, faUserLock } from '@fortawesome/free-solid-svg-icons';
import { FooterPageComponent } from './components/footer-page/footer-page.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    FooterPageComponent,
    NavMenuComponent,
    FooterPageComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    SharedModule,
  ],
  exports: [
    FooterPageComponent,
    NavMenuComponent,
  ]
})
export class CoreModule {

  constructor(@Optional() @SkipSelf() parent: CoreModule, library: FaIconLibrary) {
    if (parent) {
      throw new Error('CoreModule já foi carregado. Importar apenas no AppModule.');
    }
    library.addIcons(faCoffee, faLockOpen, faUserLock, faUser, faLock, faKey, faGlobe, faNewspaper, faDumbbell); // Adicione os ícones que vai usar
  }
}